import { render, staticRenderFns } from "./OrderFormDynamic.vue?vue&type=template&id=6885d977&"
import script from "./OrderFormDynamic.vue?vue&type=script&lang=js&"
export * from "./OrderFormDynamic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports